module.exports = __webpack_public_path__ + "img/chandanni.4c53d20a.png";